import React from 'react';
import warning from "../../../assets/img/Models/warning.svg";


const UploadUnsuccessfulModal = ({
    storedDETData
}) => {
    return (
        <div className='text-center'>
            <div>
                <img
                    src={warning}
                    className="mb-3"
                    style={{
                        width: "4rem"
                    }}
                />
            </div>
            <p className='label mt-4'>Oops! Looks like you have made a mistake while <br />
                uploading. Your file was not uploaded.</p>
            <p className='mt-4 note-det-code-text'>
                Please download the failure file and retry after <br />
                making the necessary changes. {" "}
                <a href={storedDETData.invalid_codes_download_url} className='download-file'>
                    error.xlxs
                    <i class="fa fa-download ml-1"></i>
                </a>
            </p>
            <style jsx>{`
                .det-upload-code-date{
                    padding: 20px 20px;
                    border: 1px solid #E2E2E2;
                    border-radius: 5px;
                    background: #F8F8F8;
                }

                .note-det-code-text{
                    font-family: Hind;
                    font-size: 15px;
                    font-weight: 400;
                    line-height: 24.02px;
                    color: #6D7780;
                }
                    .download-file{
                        color: #007BFF;
                        cursor: pointer;
                        text-decoration: underline;
                    }
             `}</style>
        </div>
    )
}

export default UploadUnsuccessfulModal